<template>
    <div class="box has-text-black has-text-weight-bold flex align-items-top">
        <div class="flex-shrink">
            <div class="flex pr-2">
                <i class="fal fa-comment-alt-exclamation fa-2x mr-5"></i>
                <div class="has-text-size-14">
                    <h3 v-if="announcement.label">{{ announcement.label }}</h3>
                    <div v-html="parsedMessage" class="content"></div>
                </div>
            </div>
        </div>
        <div>
            <div v-if="onClick" class="has-cursor-pointer"
                 @click="onClick(announcement)"
                 :data-testid="`close-announcement-${announcement.id}`"
                 >
                <i class="fal fa-times fa-2x"></i>
            </div>
        </div>
    </div>
</template>

<script>
  import { Announcement } from '../../../models/Announcement';
  import MarkdownIt from 'markdown-it';

  export default {
    props: {
      announcement: {
        type: Announcement,
        required: true
      },
      onClick: {
        type: Function,
        required: false
      }
    },
    computed: {
      parsedMessage () {
        let md = new MarkdownIt();
        return md.render(this.announcement.message);
      }
    }
  };
</script>

<style lang="scss" scoped>
  $color: #e50348;

  .box {
    color: $color;
    border: 1.5px solid $color;
    border-radius: 2px;
    padding: 1.4rem;
  }

  .fa-bullhorn, .fa-times, .fa-comment-alt-exclamation {
    color: $color;
  }

</style>
